import React from "react";
import LayoutComponent from "@ui/layout/LayoutComponent";
import {Badge, Breadcrumb} from "antd";
import {CheckSquareOutlined, SecurityScanOutlined, UnorderedListOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import "./completed-system.scss";


const CompletedSystem = () => {

    let system = {
        id: 15,
        systemName: `Программное обеспечение искусственного интеллекта "Железный человек" Военно-воздушных сил Соединенных Штатов Америки`,
        applicant: "Военно-воздушные силы Соединенных штатов Америки",
        owner: "Военно-воздушные силы Соединенных штатов Америки",
        workType: 5,
        year: 2022,
        ContractType: "ПГЗ",
        conclusion: "Не соответствует",
        status: "Завершено",
        conclusionIndicator: "error",
        statusIndicator: "success"
    }

    return (
        <LayoutComponent>
            <div className="breadcrumb">
                <Breadcrumb
                    style={{
                        margin: '16px 0',
                    }}
                >
                    <Breadcrumb.Item>
                        <UnorderedListOutlined/>
                        <span>Список</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={'/systems'}>
                            <SecurityScanOutlined/>
                            <span>Испытания</span>
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={'/systems/completed'}>
                            <CheckSquareOutlined/>
                            <span>Завершены</span>
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <span>{system.systemName}</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="completed-system">
                <div className="card">
                    <div className="first-testing">
                        <h3 className="card-title">Основное испытание</h3>
                        <div className="card-row">
                            <table>
                                <tr>
                                    <th colSpan="2" className="center">Общая информация по объекту испытания</th>
                                </tr>
                                <tr>
                                    <th>Объект испытания</th>
                                    <td>{system.systemName}</td>
                                </tr>
                                <tr>
                                    <th>Заявитель</th>
                                    <td>{system.applicant}</td>
                                </tr>
                                <tr>
                                    <th>Владелец</th>
                                    <td>{system.owner}</td>
                                </tr>
                                <tr>
                                    <th>Год</th>
                                    <td>2022</td>
                                </tr>
                                <tr>
                                    <th>Начало испытания</th>
                                    <td>01.03.2022</td>
                                </tr>
                                <tr>
                                    <th>Внутренний срок испытания</th>
                                    <td>15.04.2022</td>
                                </tr>
                                <tr>
                                    <th>Внешний срок испытания</th>
                                    <td>22.04.2022</td>
                                </tr>
                                <tr>
                                    <th>Вид договора</th>
                                    <td>{system.ContractType}</td>
                                </tr>
                                <tr>
                                    <th>Заключение</th>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th>Статус</th>
                                    <td><Badge status={system.statusIndicator}/>{system.status}</td>
                                </tr>
                                <tr>
                                    <th>ЦОД</th>
                                    <td>AWO KL NASA</td>
                                </tr>
                            </table>
                            <table className="second-table">
                                <tr>
                                    <th colSpan="2" className="center">Заключения протоколов по видам испытаний</th>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">АИК</th>
                                </tr>
                                <tr>
                                    <td>Шерхан Тулкибай</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ФИБ</th>
                                </tr>
                                <tr>
                                    <td>Данияр Олегов</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ОПОИБ</th>
                                </tr>
                                <tr>
                                    <td>Смагулов Асылан</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">Нагрузка</th>
                                </tr>
                                <tr>
                                    <td>Бажаев Нуржан</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ОСИ</th>
                                </tr>
                                <tr>
                                    <td>Ерлан Ешмухамедов</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="second-testing">
                        <h3 className="card-title">Повторное испытание</h3>
                        <div className="card-row">
                            <table>
                                <tr>
                                    <th colSpan="2" className="center">Общая информация по объекту испытания</th>
                                </tr>
                                <tr>
                                    <th>Объект испытания</th>
                                    <td>{system.systemName}</td>
                                </tr>
                                <tr>
                                    <th>Заявитель</th>
                                    <td>{system.applicant}</td>
                                </tr>
                                <tr>
                                    <th>Владелец</th>
                                    <td>{system.owner}</td>
                                </tr>
                                <tr>
                                    <th>Год</th>
                                    <td>2022</td>
                                </tr>
                                <tr>
                                    <th>Начало испытания</th>
                                    <td>15.05.2022</td>
                                </tr>
                                <tr>
                                    <th>Внутренний срок испытания</th>
                                    <td>21.06.2022</td>
                                </tr>
                                <tr>
                                    <th>Внешний срок испытания</th>
                                    <td>28.06.2022</td>
                                </tr>
                                <tr>
                                    <th>Вид договора</th>
                                    <td>{system.ContractType}</td>
                                </tr>
                                <tr>
                                    <th>Заключение</th>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th>Статус</th>
                                    <td><Badge status={system.statusIndicator}/>{system.status}</td>
                                </tr>
                                <tr>
                                    <th>ЦОД</th>
                                    <td>AWO KL NASA</td>
                                </tr>
                            </table>
                            <table className="second-table">
                                <tr>
                                    <th colSpan="2" className="center">Заключения протоколов по видам испытаний</th>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">АИК</th>
                                </tr>
                                <tr>
                                    <td>Шерхан Тулкибай</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ФИБ</th>
                                </tr>
                                <tr>
                                    <td>Данияр Олегов</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ОПОИБ</th>
                                </tr>
                                <tr>
                                    <td>Смагулов Асылан</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">Нагрузка</th>
                                </tr>
                                <tr>
                                    <td>Бажаев Нуржан</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2" className="center">ОСИ</th>
                                </tr>
                                <tr>
                                    <td>Ерлан Ешмухамедов</td>
                                    <td><Badge status={system.conclusionIndicator}/>{system.conclusion}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutComponent>
    )
}

export default CompletedSystem;
